import React, { useState, useEffect, useRef } from 'react';
import styles from '../../styles/Messenger.module.css';
import ItemMessages from '../ApplicationContent/ItemMessages';

import * as firebase from 'firebase/app';
import moment from 'moment';

//let data: any;
const Messenger = (props) => {

    const [allMessages, setAllMessages] = useState();
    const [message, setMessage] = useState("");

    let userId = props.data // getting UID
    //let ind = props.idata // getting index WHY ??

    console.log(userId);
    const isCurrent = useRef(true);

    useEffect(() => {
        return () => {
            isCurrent.current = false;
        }
    }, [])

    const getDataFirebase = (userId) => {
        //let array: any;
        let data;
        // getting data from location for MEDICINE
        let getData = firebase.database().ref('/users/' + userId + '/messages');
        getData.on('value', function(snapshot) {
            console.log(snapshot.val());
            console.log("data?FB-messages")
            data = snapshot.val();
            if (data !== null) {
                // getting data to correct form ID:, DATe, Medicine, howMuch, ManyTImes:
                const allMessagesArray = Object.keys(data).map( key => {
                    return  { 
                        id: key, 
                        date: data[key].date,
                        time: data[key].time,
                        message: data[key].message,
                        author: data[key].author
                    };
                })
                //set in reverse order so the last input is 1 in line
                //checking for componenet is mounted !!.reverse()
                if (isCurrent.current) { setAllMessages(allMessagesArray) }  
            } 
        })
    }
    // NEW ADDITION MESSENGER
    function writeMessangerData(userId, message) {
        //getting unique KEY and push it - child node "WEIGHT"
        let newPostKey = firebase.database().ref('users/' + userId).child('messages').push().key;
        // what data is
        const d = new Date();
        let h = d.getHours();
        let m = d.getMinutes();
        let s = d.getSeconds();
        const someData = {
            date: moment().format("YYYY/MM/DD"),
            time: h + ":" + m + ":" + s,
            message: message,
            author: "Zdravnik"
        }
        var updates = {};
        updates['/messages/' + newPostKey] = someData;
        // and finaly UPDATE the database
        // and u must start with UPDATE ... SET doesnt work for some reason !!
        return firebase.database().ref('users/' + userId).update(updates);
    }
    const addMessageHandler = () => {
        if (message !== "") {
            writeMessangerData(userId, message)
            setMessage("")
        }
    }
    const onKeyUpSendMessage = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (e.keyCode === 13) {
          addMessageHandler();
          //console.log(message)
        }
      }

    // u need to pass [userId] so it rerenders when prop.data changes !!
    useEffect(() => {
        console.log("trying to get messages from FB.database")
        getDataFirebase(userId)
    }, [userId])

    return  (
        <div className={styles.Desktop}>
            <div className={styles.List}>
                <ItemMessages data={allMessages} />
                <div className={styles.BotMessage}>
                    <input
                        className={styles.Input}
                        type='text'
                        placeholder='Ab..'
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyUp={(e) => onKeyUpSendMessage(e)}
                    />
                    <img className={styles.Image}
                        onClick={() => addMessageHandler()}
                        src={require('../../icons/send-around.png')}
                        alt="send-icon" />
                    
                </div>
                
            </div>
        </div>
    ) 
}

export default Messenger;
